import * as React from "react";
import type { SVGProps } from "react";
const SvgIconExpandDiagonal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.07c-.2.04-.37.22-.43.41-.08.33.12.65.45.71q.1.02 1.53.02h1.43l-1.93 1.93C10 5.2 9.11 6.1 9.1 6.13c-.1.18-.09.4.01.57q.07.12.19.19.28.17.58.02c.03-.02.93-.9 1.99-1.96l1.93-1.93v1.43q0 1.44.02 1.53.04.18.16.3c.1.09.15.12.24.15.28.07.56-.06.68-.32l.05-.1V1.5l-.06-.1q-.1-.2-.29-.3l-.09-.03h-4.49M6.25 9.05q-.05.01-.11.04c-.03.02-.93.9-1.99 1.96l-1.93 1.93v-1.43q0-1.43-.02-1.53-.04-.18-.16-.3c-.1-.09-.15-.12-.24-.14-.28-.08-.56.05-.68.32l-.05.1v4.51l.06.1q.1.2.29.28l.09.05H6l.1-.05c.26-.12.39-.4.32-.67-.06-.21-.24-.37-.45-.41q-.1-.02-1.53-.02H3.02l1.93-1.94C7.11 9.7 6.96 9.86 6.97 9.62q.01-.2-.11-.38c-.06-.08-.2-.17-.3-.2-.08-.02-.25-.02-.32 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconExpandDiagonal;
